/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { TRIGGERED_BROADCASTS_TABLE_SORT_OPTIONS } from 'cio/utils/campaigns/sort-options';
import CampaignModel from 'cio/models/campaign';
import SubscriptionCenterService from 'cio/services/subscription-center';
import ObjectTypesService from 'cio/services/object-types';

interface TriggeredBroadcastsFiltersArgs {
  broadcasts: CampaignModel[];
  sort: string;
  sortDescending: boolean;
  tagIds: string[];
  topic: string | null;
  onAddTags: () => unknown;
  onSetSortDescending: (sortDescending: boolean) => unknown;
  onChangeTopic: (topic: { label: string; value: string } | null) => unknown;
  selectedObjectTypeIds: string[];
  onObjectTypeIdsChange: (objectTypeIds: string[]) => unknown;
}

export default class TriggeredBroadcastsFilters extends Component<TriggeredBroadcastsFiltersArgs> {
  @service subscriptionCenter!: SubscriptionCenterService;
  @service objectTypes!: ObjectTypesService;

  _sorts = TRIGGERED_BROADCASTS_TABLE_SORT_OPTIONS;

  constructor(owner: unknown, args: TriggeredBroadcastsFiltersArgs) {
    super(owner, args);

    this.subscriptionCenter.initializeTask.perform();
  }
}
